export default __webpack_public_path__ + "static/media/persevere_2.21271234.jpg";